import {Theme} from 'stores/AppStore';
import {transparentize} from 'polished';
import {ThemeObject} from 'types';

export default {
  name: Theme.Light,
  variables: {
    transitionDelay: '.25s',
    transitionTimingFunction: 'ease-out',
    color: '#2E2E2F',
    placeholderColor: transparentize(.8, '#000000'),
    inputLabelColor: transparentize(.2, '#000000'),
    inputNoteColor: transparentize(.6, '#ffffff'),
    borderColor: transparentize(.9, '#282B34'),
    tableBorderColor: '#343436',
    accentColor: '#363636',
    accentBackgroundColor: '#ffffff',
    backgroundColor: '#F2F4F9',
    boxShadowColor: transparentize(.9, '#282B34'),
  },
  colors: {
    white: '#ffffff',
    black: '#000000',
    primary: '#3264EF',
    blueViolet: '#7398FF',
    primaryLight: '#507EFF',
    goldenLight: '#FFF280',
    red: '#FF647C',
    silver: '#C4C4C4',
    green: '#00C48C',
  },
} as ThemeObject;
